import { DynamicLoaderRegistry, ColorFrom } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { AngleFrom, ColorOperations, NumberInputFrom } from '@tencent/wb-ext-form';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import { IShadowModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import React from 'react';

export interface IShadowFeature extends IBaseDrawerFeature {
    shadowInfoInDrawer: IShadowModelVal;
    readonly shadowInfoInModel: IShadowModelVal;
    readonly isMultiDifferent: boolean;
    readonly size: number;
    readonly blur: number;
    readonly dist: number;
    readonly opacity: number;
    readonly dir: number;
    renderPreset(): ReactElement;
    getPresetMenuContent(props?: { style: React.CSSProperties }): ReactElement;
    handleShadowChange(value, dragEnd?: boolean, from?: NumberInputFrom | AngleFrom);
    updateShadowProps(onlyChangeUI?: boolean, onPreview?: boolean);
    handleShadowPresetStyleClick(shadow);
    handleShadowPresetSytleEnter(shadow);
    handleShadowPresetStyleMouseLeave();
    handleColorChange(options, from: ColorFrom | number);
    handlePresetVisibleChange(visible: boolean);
    handleColorPanelOperate(value: string, from: ColorFrom, mouseMoveType: ColorOperations);
    handleColorEnter(color);
    handlePaletteLeave();
    getColorSelectButton();
    shouldSizeDisabled(): boolean;

}

export const IShadowFeature = Symbol.for('feature:drawer-font-shadow');

DynamicLoaderRegistry.merge(IShadowFeature, {
    useFactory: async () => {
        const { ShadowFeature } = await import('./shadow-feature');
        return ShadowFeature;
    },
    on: loadTask,
});
